import { Button, Link } from "@material-ui/core";
import React from "react";
import ReactMarkdown from "react-markdown";
import htmlParser from "react-markdown/plugins/html-parser";
import styled from "styled-components";
import { Text } from "../../Primitives";
const Reset = styled.div `
  padding-bottom: ${(props) => (props.noPadding ? 0 : "8rem")};

  img {
    max-width: 100%;
    margin: 1rem auto 2rem auto;
  }

  ul {
    li + li {
      margin-top: 0.5rem;
    }
  }

  p + p {
    margin-top: 1rem;
  }

  h1 {
    margin-top: 2.5rem;
  }

  h2 {
    margin-top: 2.5rem;
  }

  h3 {
    margin-top: 2.25rem;
  }

  h4 {
    margin-top: 2rem;
  }

  h5 {
    margin-top: 1.25rem;
  }

  h6 {
    margin-top: 1.25rem;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    & + h1,
    & + h2,
    & + h3,
    & + h4,
    & + h5,
    & + h6 {
      /* margin-top: 0; */
    }
  }
`;
const Section = styled.section `
  position: relative;
  margin: 4rem 0;

  &:before {
    content: "";
    border-left: 4px solid #fa255e;
    position: absolute;
    top: 0;
    left: -32px;
    bottom: 0;
    border-radius: 10px;

    @media (max-width: 600px) {
      border-left-width: 8px;
      border-radius: calc(7px + 10%);
      left: -36px;
    }
  }
`;
const LinkButton = (props) => {
    return (React.createElement("a", { href: props.link },
        React.createElement(Button, { style: {
                display: "block",
                margin: "1.5rem auto"
            } }, props.children)));
};
const parseHtml = htmlParser({
    isValidNode: (node) => node.type !== "script",
    processingInstructions: [
        {
            shouldProcessNode: function (node) {
                return node.name === "button";
            },
            processNode: function (node, children) {
                return React.createElement(LinkButton, { link: node.attribs.link }, children);
            }
        },
        {
            shouldProcessNode: function (node) {
                return node.name === "section";
            },
            processNode: function (node, children) {
                return React.createElement(Section, null, children);
            }
        }
    ]
});
export const RichText = (props) => {
    const { compact } = props;
    return (React.createElement(Reset, { noPadding: props.noPadding },
        React.createElement(ReactMarkdown, { source: props.text, escapeHtml: false, renderers: {
                paragraph: (props) => (React.createElement(Text, { gutterBottom: true, style: { fontSize: compact ? 14 : "1rem" } }, props.children)),
                heading: (props) => (React.createElement(Text, { gutterBottom: true, variant: compact ? "h6" : `h${props.level}` }, props.children)),
                link: Link
                // button: Button,
            }, astPlugins: [parseHtml] })));
};
//# sourceMappingURL=RichText.js.map